import config from 'config.json';

ClientesFactory.$inject = ['$resource'];

export default function ClientesFactory($resource) {
  let Clientes = $resource(config.serverURL + '/clientes/:id', { id: '@id' });

  return {
    all: all
  };

  function all() {
    return Clientes.query();
  }
}


// WEBPACK FOOTER //
// ./src/components/clientes/list/factory.js